import { z } from 'zod';

export const vehicleSchema = z.object({
    vehicle_id: z.number(),
    dispatcher_id: z.number(),
    vehicleType_id: z.number(),
    maxHeight: z.coerce.number().nullable(),
    maxLength: z.coerce.number().nullable(),
    maxWeight: z.coerce.number().nullable(),
    maxWidth: z.coerce.number().nullable(),
});
export type TVehicle = z.infer<typeof vehicleSchema>;
